import { render, staticRenderFns } from "./Viewer.vue?vue&type=template&id=3334167f&scoped=true&shadow"
import script from "./Viewer.vue?vue&type=script&lang=js&shadow"
export * from "./Viewer.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./Viewer.vue?vue&type=style&index=0&id=3334167f&scoped=true&lang=css&shadow")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./Viewer.vue?vue&type=style&index=1&lang=css&shadow")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3334167f",
  null
  ,true
)

export default component.exports